import { createWrapper } from "next-redux-wrapper";
import { applyMiddleware, createStore, Middleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";

import { loadState, saveState, throttle } from "./../src/utils/index";
import rootReducer from "./reducers";
import rootSaga from "./saga";

const bindMiddleware = (middleware: Middleware<any, any, any>[]) => {
  if (process.env.NODE_ENV !== "production") {
    return composeWithDevTools(applyMiddleware(...middleware));
  }
  return applyMiddleware(...middleware);
};

export const makeStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const persistState = loadState();
  const store = createStore(
    rootReducer,
    persistState,
    bindMiddleware([sagaMiddleware])
  );

  (store as any).sagaTask = sagaMiddleware.run(rootSaga);

  store.subscribe(
    throttle(() => {
      saveState({ auth: store.getState().auth });
    }, 100)
  );
  return store;
};

export const wrapper = createWrapper(makeStore, { debug: true });
